//angular imports
import { ChangeDetectionStrategy, Component, OnDestroy, Signal } from '@angular/core';
import { FormControl } from '@angular/forms';
import { Router } from '@angular/router';
import { CommonConstants } from '@app/app-common';

//local imports
import { SearchChangedMessage, SearchModel } from '@app/core';
import { BreadcrumbItemToggleMessage, Messenger } from '@app/shared';

@Component({
  selector: 'search',
  standalone: false,
  templateUrl: './search.component.html',
  styleUrl: './search.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class SearchComponent implements OnDestroy {
  public searchControl = new FormControl('');
  public searchMessageChanged: Signal<SearchChangedMessage>;

  constructor(
    private messenger: Messenger,
    private router: Router
  ) {
    this.messenger.subscribe(this, SearchChangedMessage, (message) => {
          if(!message.searchValues.length) {
            this.searchControl.reset();
          }
    });
  }

  public onSearch(event: KeyboardEvent): void {
    const value = this.searchControl.value?.trim();
    if(value){
      const model = new SearchModel();
      model.id = crypto.randomUUID();
      model.name.set(value);


    const currentUrl = this.router.url;

    if (currentUrl.includes(CommonConstants.ROUTES.CATALOG)) {
        this.messenger.send(new BreadcrumbItemToggleMessage(model, CommonConstants.CATALOG));
      } else if (currentUrl.includes(CommonConstants.ROUTES.SERVICE_MATRIX)) {
        this.messenger.send(new BreadcrumbItemToggleMessage(model, CommonConstants.SERVICE_MATRIX));
      } else {
        this.messenger.send(new BreadcrumbItemToggleMessage(model));
      }
    }
    this.searchControl.reset();
  }

  ngOnDestroy(): void {
    this.messenger.unsubscribeByOwner(this);
  }

}
